import React from "react";
import $ from "jquery";
import "select2/dist/js/select2.min";
import "select2/dist/css/select2.min.css";

export default class Select2 extends React.Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
  }

  componentDidMount() {
    const $select = $(this.selectRef.current);

    if (!$select.hasClass("select2-hidden-accessible")) {
      $select.select2({
        placeholder: "Select an option",
        allowClear: true,
        width: "100%",
      });

      $select.on("select2:select", this.props.onChange);
    }

    // Set initial selected value
    if (this.props.value !== undefined) {
      $select.val(this.props.value).trigger("change");
    }
  }

  componentDidUpdate(prevProps) {
    const $select = $(this.selectRef.current);

    // Update selected value if it changes
    if (prevProps.value !== this.props.value) {
      $select.val(this.props.value).trigger("change");
    }
  }

  componentWillUnmount() {
    const $select = $(this.selectRef.current);
    $select.off("select2:select");
    $select.select2("destroy");
  }

  render() {
    const { children, value, ...props } = this.props;

    return (
      <select
        {...props}
        ref={this.selectRef}
        value={value} // Controlled value
        style={{ display: "none" }}
      >
        {children}
      </select>
    );
  }
}